import { render } from 'preact';
import { HeadlessMantineProvider } from '@mantine/core';
import { FeaturedProductSection } from '../../../react-components/FeaturedProductSection';

export async function Root(element, data) {
  let { section } = data;

  function FeaturedProduct() {
    return (
      <HeadlessMantineProvider>
        <FeaturedProductSection section={section} />
      </HeadlessMantineProvider>
    );
  }

  render(<FeaturedProduct />, element);
}
